import { PortActionTypes } from '@shared/utils/constants';
import { calculateTotal } from '@shared/utils/math';
import normalizeNumber from '@shared/utils/normalizeNumber';
import type { CargoDetails } from '@api/features/cargos/getCargoDetails';
import type { LocalPortRotation } from '../context/hooks/usePortRotationHandlers';

export const hasCargoQtyMismatch = (
	cargos: CargoDetails[],
	portRotation: LocalPortRotation[],
) => cargos.some((c) => {
	const loadingEntries = portRotation.filter((p) => p.cargoId === c.id && p.type === PortActionTypes.LOADING);
	const dischargingEntries = portRotation.filter((p) => p.cargoId === c.id && p.type === PortActionTypes.DISCHARGING);

	const qtyLoaded = calculateTotal(loadingEntries, (p) => normalizeNumber(p.qty));
	const qtyDischarged = calculateTotal(dischargingEntries, (p) => normalizeNumber(p.qty));

	return qtyLoaded != c.quantity || qtyDischarged != c.quantity;
});
